export const LIBRARY_TREE = "LIBRARY_TREE";
export const LIBRARY_ALL_DATA = "LIBRARY_ALL_DATA";

export const setLibraryTreeData = (object) => {
   return {
      type: LIBRARY_TREE,
      payload: object,
   };
};

export const setLibraryAllData = (object) => {
   return {
      type: LIBRARY_ALL_DATA,
      payload: object,
   };
};
